import React from "react";
import { Jumbotron, Grid, Col, Button } from "react-bootstrap";
import { Link } from "react-router-dom";

const HomeScreen = (props) => (
  <div>
    <Jumbotron>
      <h1>Ubivox E-mail Tools</h1>
      <p>
        This is our small toolbox used to debug common problems with 
        e-mail deliverability. 
      </p>
      <p><a className="btn btn-primary btn-lg" href="https://www.ubivox.com" role="button">Learn more about Ubivox &raquo;</a></p>
    </Jumbotron>
    <Grid>
      <Col md={3}>
        <h2>DNS</h2>
        <p className="frontpage-teaser-text">Perform simple DNS queries. Validates DNSSEC as well.</p>
        <p><Button bsStyle="info" componentClass={Link} to={"/dns"}>Lookup DNS records &raquo;</Button></p>
      </Col>
      <Col md={3}>
        <h2>SPF</h2>
        <p className="frontpage-teaser-text">Validate SPF records from DNS and get an approvimate list of the networks and hosts allowed by the policy.</p>
        <p><Button bsStyle="info" componentClass={Link} to={"/spf"}>Check SPF policies &raquo;</Button></p>
      </Col>
      <Col md={3}>
        <h2>RBL</h2>
        <p className="frontpage-teaser-text">Check if your IP address is listed in common RBLs (Real-time Blackhole List).</p>
        <p><Button bsStyle="info" componentClass={Link} to={"/rbl"}>Find RBL status &raquo;</Button></p>
      </Col>
      <Col md={3}>
        <h2>Network</h2>
        <p className="frontpage-teaser-text">Retrieve various details about the network of IP addresses.</p>
        <p><Button bsStyle="info" componentClass={Link} to={"/network"}>Get the network details &raquo;</Button></p>
      </Col>
    </Grid>
  </div>
);

export default HomeScreen;



// WEBPACK FOOTER //
// ./src/Home.js